export const MAX_TIME_IN_BACKGROUND = 21600000;
export const BACKGROUND_EVENT_NAME = 'appBackgrounded';
